export default __webpack_public_path__ + "assets/models/aae8f39e18f1de3df8c1515494cf7c38.glb";